import "./styles/index.scss";

import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { createHead } from "@vueuse/head";
import limitViewportWidth from "./utils/limitViewportWidth";

import { init as initSentry } from "./services/sentry";

const app = createApp(App);
if (process.env.NODE_ENV === "production") initSentry(app, router);
app.use(createHead()).use(router).mount("#app");

// Limit window width
limitViewportWidth(380);
